import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import enums from '../enum';
import addressModel, { IAddress } from './addressModel';
import contactAdditionalInfoModel, { IContactAdditionalInfo } from './contactAdditionalInfoModel';
import phonable, { IPhonable } from './phonable';
import person, { IPerson } from './person';
import model from './model';
import { IModelSet } from 'Scripts/modelSet';
import additionalInfoContainer, {IAdditionalInfoContainer} from './additionalInfoContainer';

export interface IContact extends IModel, IPerson, IPhonable, IAdditionalInfoContainer<IContactAdditionalInfo> {
	readonly parentContactKey?: string;
	readonly rootContactKey?: string;
	jobKey?: string;
	contractorKey?: string;
	externalFormKey?: string;
	preferredContactMethod?: number;
	priority?: number;
	title?: string;
	// additionalInfo: IModelSet<IContactAdditionalInfo>;
	addresses: IModelSet<IAddress>;
	officeAddress?: IAddress;
	readonly preferredContactMethodValue?: string;
	isEmpty(): boolean;
	createChild(overrides: Partial<IContact>): IContact;
}

const contactFactory = modelFactory.createFactory<IContact>('Contact', _.assign({}, model, person, phonable, additionalInfoContainer, {
	parentContactKey: {
		writable: false
	},
	rootContactKey: {
		writable: false
	},
	jobKey: {
		setFilters: valueFilters.clean
	},
	contractorKey: {
		setFilters: valueFilters.clean
	},
	externalFormKey: {
		setFilters: valueFilters.clean
	},
	preferredContactMethod: {
		setFilters: valueFilters.toNumber,
		rules: [validator.enum('contactMethods'),
			(v, t) => {
				if (t.priority === 0 && !t.externalFormKey) { // only require this for primary contacts
					return (!t.preferredContactMethodValue) ? 'Preferred Contact Method is missing.' : undefined;
				}
			}
		]
	},
	priority: {
		setFilters: valueFilters.toNumber
	},
	title: {
	},
	additionalInfo: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(contactAdditionalInfoModel),
		rules: validator.validModel(contactAdditionalInfoModel.rules())
	},
	addresses: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(addressModel),
		rules: validator.validModel(addressModel.rules())
	},
	_get_officeAddress: function () {
		const result = this.getAddressByType(enums.addressTypes.Office);

		return result ? result : undefined;
	},
	_set_officeAddress: function (val) {
		this.setAddressOfType(val, enums.addressTypes.Office);
	},
	preferredContactMethodValue: {
		writable: false,
		nonSerialized: true
	},
	_get_preferredContactMethodValue: function () {
		const contactMethods = enums.contactMethods;

		switch (this.preferredContactMethod) {
		case contactMethods.Email:
			return this.emailAddress;
		case contactMethods.Home_Phone:
			return this.homePhoneNumber;
		case contactMethods.Office_Phone:
			return this.workPhoneNumber;
		case contactMethods.Mobile_Phone:
			return this.mobilePhoneNumber;
		default:
			return;
		}
	},
	// getAdditionalInfo: function (name) {
	// 	if (!this.additionalInfo) { return; }

	// 	return _.find(this.additionalInfo, { name });
	// },
	// getAdditionalInfoValue: function (name, defaultValue = '') {
	// 	const info = this.getAdditionalInfo(name);

	// 	return info && info.value || defaultValue;
	// },
	// setAdditionalInfo: function (name, value) {
	// 	if (!this.additionalInfo) { return; }

	// 	const isUndefined = typeof value === 'undefined' || value === '';
	// 	let result = this.getAdditionalInfo(name);

	// 	if (!result) {
	// 		result = this.additionalInfo.add({ name });
	// 	}

	// 	if (result) {
	// 		if (isUndefined) {
	// 			this.additionalInfo.delete(result.key);
	// 			result = undefined;
	// 		}
	// 		else {
	// 			result.value = value;
	// 		}
	// 	}

	// 	return result;
	// },
	isEmpty: function () {
		return !this.firstName && !this.lastName && !this.emailAddress && !this.avatarUrl && (!this.addresses || this.addresses.toArray().length === 0) && (!this.phoneNumbers || this.phoneNumbers.toArray().length) === 0;
	},
	createChild: function (overrides) {
		const clonedDoc = this._toDocument(undefined, ['key', 'itemVersion', 'dateCreated', 'dateLastModified', 'parentContactKey']);

		return contactFactory(_.assign(clonedDoc, {
			parentContactKey: this.key
		}, overrides));
	}
}));

export default contactFactory;